// @ts-nocheck
'use strict';
import $ from 'jquery';
var common = require('./utils/common.js').default;

function setUpUI() {
  let popup_cookie_name = ''
  if($("#popup_page1").text() == "AP"){
    popup_cookie_name = 'manager_popup'
  } else{
    popup_cookie_name = 'study_popup'
  }
  //modal 팝업 띄울지
//  if (common.getCookie(popup_cookie_name) != 'rangs1'){
//    $('#popup_modal1').modal('show');
//  } else if(common.getCookie(popup_cookie_name) != 'rangs2') {
//    $('#popup_modal2').modal('show');
//  }
   $('#popup_modal1').modal('show');
$('#popup_modal2').modal('show');

    var img = $("#pop_img_1");

    img.on('load', function() {
        var imageWidth = img.width();
        // 여기서 이미지의 폭을 사용하여 필요한 조건에 따라 다른 동작 수행 가능
        console.log("Image width: " + imageWidth);

        // 예: 이미지 폭이 특정 값보다 큰 경우 width를 조절
//        if (imageWidth > 500) {
//            img.width(500); // 원하는 폭으로 조절
//        }
    });


  $("#close_until1").on('click', function(){
    common.setCookie(popup_cookie_name,'rangs1',1)
    console.log("close_until1")
    if(this.checked) {
      $('#popup_modal1').modal('hide');
    }
    
  })

  $("#close_until2").on('click', function(){
    common.setCookie(popup_cookie_name,'rangs2',1)
    console.log("close_until2")
    if(this.checked) {
      $('#popup_modal2').modal('hide');
    }

  })
}


setUpUI();
